<div class="h-full">
  <app-instruction-detail></app-instruction-detail>
</div>
